<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar class="headline gradiente lighten-2 elevation-3">
          <v-toolbar-title>
            <v-flex xs12>
              <div class="white--text">{{ title }}</div>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex pt-3 px-4>
          <v-text-field
            v-model="filters.search"
            @keyup.enter="
              filters.offset = 0
              getAllStudents(true)
            "
            :label="$t('parents.table_tutors.search_student')"
            append-icon="search"
            :disabled="working.wUpdate"
            :autofocus="!working.wUpdate"
            clearable
          >
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                {{ $t('parents.table_tutors.help_search_student') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-card-text id="contentStudentsModal">
          <v-list subheader two-line>
            <v-subheader>
              {{ $t('parents.table_tutors.select_the_students') }}
            </v-subheader>
            <template v-for="(item, index) in students">
              <v-list-tile :key="index" avatar>
                <v-list-tile-action>
                  <v-checkbox
                    color="primary"
                    :value="item"
                    :id="index + ''"
                    v-model="selectedStds"
                    :disabled="isHisChild(item)"
                    v-bind:key="item.id"
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-avatar>
                  <v-icon :color="item.gender == 'MALE' ? 'blue' : 'pink'"
                    >account_circle</v-icon
                  >
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="
                      item.firstName +
                      ' ' +
                      item.lastName +
                      (isHisChild(item) ? ', ya es su tutorado.' : '')
                    "
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="
                      item.level.typeLevel +
                      ', ' +
                      item.gg.grade +
                      '' +
                      item.gg.group
                    "
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('parents.table_tutors.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="preventlinkConfirm"
          >
            {{ $t('parents.table_tutors.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success
      v-if="parent !== null"
      v-model="toast.success"
      text="Creación Exitosa"
    ></success>
    <success
      v-else
      v-model="toast.success"
      text="Actualización Exitosa"
    ></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <confirm
      :value="confirm.value"
      :title="confirm.title"
      :description="confirm.description"
      v-on:desition="desitionLink"
    ></confirm>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import confirm from '../Dialogs/Confirm'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
export default {
  props: ['title', 'parent', 'value', 'parentName'],
  components: {
    loading,
    success,
    error,
    confirm,
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required },
      level: {
        id: { required },
      },
      gg: {
        id: { required },
      },
    },
  },
  watch: {
    value() {
      this.selectedStds = []
      if (this.value) {
        this.students = []
        this.getAllStudents()
        document
          .getElementById('contentStudentsModal')
          .addEventListener('scroll', this.handleScroll)
      } else {
        document
          .getElementById('contentStudentsModal')
          .removeEventListener('scroll', this.handleScroll)
      }
    },
  },
  beforeDestroy() {},
  mounted() {},
  data: () => ({
    modals: {
      image: false,
    },
    userForm: {
      level: {
        id: 0,
      },
      gg: {
        id: 0,
      },
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    flags: {
      updateImage: false,
    },
    selectedStds: [],
    added: 0,
    students: [],
    stdsToAdd: [],
    list: {
      header: 'Selecciona los estudiantes a ligar',
    },
    totalStudents: '',
    filters: {
      size: 10,
      offset: 0,
      search: '',
    },
  }),
  methods: {
    text: (item) => item.grade + '' + item.group,
    setInfoToShowOnUpdate() {},
    handleScroll() {
      var event = document.getElementById('contentStudentsModal')
      if (event.offsetHeight + event.scrollTop >= event.scrollHeight) {
        if (this.students.length < this.totalStudents) {
          this.filters.offset = this.students.length + 1
          this.getAllStudents()
        }
      }
    },
    getAllStudents(flag = false) {
      this.working.wUpdate = true
      this.$store
        .dispatch('student/getStudentsByBranch', this.filters)
        .then((response) => {
          // it's necesarely clear checkboxes model in order to avoid checked issue
          let auxSelected = Array.from(this.selectedStds)
          this.selectedStds = []

          this.students = flag
            ? Array.from(response.data.entity)
            : [...this.students, ...response.data.entity]

          this.selectedStds = auxSelected

          this.totalStudents = response.data.filters.total
          this.loading = false
          this.working.wUpdate = false
          this.setInfoToShowOnUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wUpdate = false
          this.toast.failed = true
        })
    },

    async submit() {
      this.added = 0
      if (this.selectedStds) {
        this.working.wUpdate = true
        for (var item in this.selectedStds) {
          await this.$store
            .dispatch('tutor/addChildToParent', {
              pid: this.parent,
              sid: this.selectedStds[item].id,
            })
            .then((response) => {
              this.$emit('linked', this.selectedStds[item])
              if (this.added == this.selectedStds.length - 1) {
                this.working.wUpdate = false
                this.toast.success = true
                this.close()
              }
              this.added++
            })
            .catch((error) => {
              if (this.added == this.selectedStds.length - 1) {
                this.working.wUpdate = false
                this.toast.failed = true
                this.close()
              }
              this.added++
              console.log(error)
            })
        }
      }
    },
    toggleAll(val) {
      if (val) {
        for (var i in this.filteredItems) {
          this.selectedStds.push(this.filteredItems[i])
        }
      } else {
        for (var i in this.filteredItems) {
          this.selectedStds.splice(
            1,
            this.selectedStds.indexOf(this.filteredItems[i])
          )
        }
      }
    },
    preventlinkConfirm() {
      if (this.selectedStds.length > 0) {
        this.linkConfirm()
      }
    },
    linkConfirm() {
      var stds = ''
      for (var item in this.selectedStds) {
        stds +=
          this.selectedStds[item].firstName +
          ' ' +
          this.selectedStds[item].lastName +
          ', '
      }
      this.confirm.description =
        (this.selectedStds.length > 1 ? 'Los estudiantes ' : 'El estudiante ') +
        stds +
        (this.selectedStds.length > 1
          ? 'se ligarán al tutor'
          : 'se ligará al tutor ') +
        this.parentName +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    desitionLink(val) {
      this.confirm.value = false
      this.confirm.show = false
      if (val) {
        this.submit()
      }
    },
    close() {
      document.getElementById('img_edit_employee').innerHTML = ``
      document.getElementById('img_edit_employee').style.display = 'none'
      document
        .getElementById('parentContainerEmployeeImage')
        .classList.add('gradiente')
      document.getElementById('img_edit_employee_default').style.display =
        'block'
      this.selectedStds = []
      this.added = 0
      this.userForm = {
        level: {
          id: 0,
        },
        gg: {
          id: 0,
        },
      }
      this.filters = {
        size: 10,
        offset: 0,
        search: '',
      }
      this.selectedStds = []
      this.added = 0
      this.$emit('close', !this.value)
    },

    isHisChild(item) {
      for (var p in item.parents) {
        if (item.parents[p].id == this.parent) {
          return true
        }
      }
      return false
    },
  },

  computed: {
    filteredItems() {
      if (!this.filters.search) return this.students
      return this.students.filter((item) => {
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = this.filters.search
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return matcher.test(
          [
            item.firstName,
            item.lastName,
            item.firstName + ' ' + item.lastName,
          ].join()
        )
      })
    },
  },
}
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
</style>
